import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { virtualTerminalProxy } from '../../../virtualTerminalProxy'
import {
  VirtualTerminalProxyFormFieldNamesEnum
} from '../../../../../../../shared/types/virtualTerminalProxyFormFieldNamesEnum'
import { handleBlur, handleChange } from '../utils'
import { StandardInput } from '../../../../../../../shared/components/ui/forms/StandardInput'
import { InputFieldType } from '../../../../../../../shared/types/InputFieldType'

export function BaseSection (): ReactElement {
  const { showAmountError, showInvoiceNumberError, form: { errors, values } } = useSnapshot(virtualTerminalProxy, { sync: true })
  return (
    <>
      <div className={cn('flex justify-between')}>
        <StandardInput
          inputType={InputFieldType.Text}
          label="Transaction Amount"
          preLabel="$"
          placeholder="100.00"
          value={values.amount as string || ''}
          onChange={handleChange(VirtualTerminalProxyFormFieldNamesEnum.Amount)}
          onBlur={handleBlur(VirtualTerminalProxyFormFieldNamesEnum.Amount)}
          showError={showAmountError}
          errorMessage={errors.amount as string}
        />

        <StandardInput
          label="Invoice Number"
          placeholder="#12345"
          value={values.invoiceNumber as string || ''}
          onChange={handleChange(VirtualTerminalProxyFormFieldNamesEnum.InvoiceNumber)}
          onBlur={handleBlur(VirtualTerminalProxyFormFieldNamesEnum.InvoiceNumber)}
          showError={showInvoiceNumberError}
          errorMessage={errors.invoiceNumber as string}
        />

      </div>
      <div className={cn('flex justify-between')}>
        <StandardInput
          label="Notes"
          value={values.notes as string || ''}
          onChange={handleChange(VirtualTerminalProxyFormFieldNamesEnum.Notes)}
          onBlur={handleBlur(VirtualTerminalProxyFormFieldNamesEnum.Notes)}
          errorMessage={errors.notes as string}
        />
      </div>

    </>
  )
}
